import { AbstractValidator } from './abstract-validator';

export class RequiredValidator extends AbstractValidator {
    static getIdentifier() {
        return 'required';
    }
    static isApplicable(input) {
        return super.isApplicable(input) && input.hasAttribute('required');
    }
    static validate(input) {
        return (onError, onSuccess) => {
            if (input.tagName === 'TEXTAREA' && !input.value) {
                onError();
                return;
            }
            if (input.tagName === 'INPUT') {
                switch (input.type) {
                    case 'text':
                    case 'number':
                    case 'email':
                    case 'tel':
                        if (!input.value) {
                            onError();
                            return;
                        }
                        break;
                    case 'checkbox':
                        if (!input.checked) {
                            onError();
                            return;
                        }
                        break;
                    case 'radio': {
                        const selector = `[name="${input.getAttribute('name')}"]`;
                        const checkedInputs = input.form.querySelector(`${selector}:checked`);
                        if (checkedInputs === null) {
                            onError();
                            return;
                        }
                        break;
                    }
                }
                onSuccess();
            }
        };
    }
}
